// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sidebar-desktop-item svg>*{stroke:var(--color-neutral-10)}.sidebar-desktop-item .fill-svg svg>*{stroke:none;fill:var(--color-neutral-10)}.sidebar-desktop-item:hover svg>*{stroke:var(--color-primary)}.sidebar-desktop-item:hover .fill-svg svg>*{stroke:none;fill:var(--color-primary)}.sidebar-desktop-item.active svg>*{stroke:var(--color-primary)}.sidebar-desktop-item.active .fill-svg svg>*{stroke:none;fill:var(--color-primary)}.sidebar-desktop .more-content svg>*{stroke:var(--color-neutral-10)}.sidebar-desktop .more-content:hover{color:var(--color-primary)}.sidebar-desktop .more-content:hover svg>*{stroke:var(--color-primary)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"a": "#5a80fb",
	"b": "#6b88fc",
	"c": "#7b91fc",
	"d": "#8899fd",
	"e": "#95a2fd",
	"f": "#a1abfe",
	"g": "#adb4fe",
	"h": "#b8bdfe",
	"i": "#c3c6ff",
	"j": "#cdcfff",
	"k": "#d8d9ff",
	"l": "#e2e2ff",
	"m": "#ececff",
	"n": "#f5f5ff",
	"o": "#fff"
};
module.exports = ___CSS_LOADER_EXPORT___;
